import { customElement } from "lit/decorators.js";
import { Chart, type ChartDefinition } from "../Chart";

@customElement("s-median-latency-chart")
export class MedianLatencyChart extends Chart {
	protected override readonly definition: ChartDefinition = {
		title: "50th percentile latency",
		summary:
			"Round robin maintains the lowest median latency. Least connections is slightly higher, and weighted round robin is highest.",
		xMinimum: 0,
		xMaximum: 59,
		xTickStep: 4,
		yMinimum: 0,
		yMaximum: 2000,
		xAxisTitle: "Time elapsed (seconds)",
		yAxisTitle: "Response time (ms)",
		series: [
			{
				name: "Round Robin (RR) 50%ile",
				points: [
					{ x: 0, y: 524.979 },
					{ x: 1, y: 904.131 },
					{ x: 4, y: 908.297 },
					{ x: 5, y: 908.297 },
					{ x: 6, y: 899.964 },
					{ x: 7, y: 908.297 },
					{ x: 9, y: 874.965 },
					{ x: 10, y: 887.464 },
					{ x: 12, y: 862.466 },
					{ x: 17, y: 854.132 },
					{ x: 19, y: 866.632 },
					{ x: 45, y: 866.632 },
					{ x: 47, y: 874.965 },
					{ x: 59, y: 874.965 },
				],
				color: "var(--chart-orange)",
				legendLabel: "Round Robin",
			},
			{
				name: "Weighted Round Robin (WRR) 50%ile",
				points: [
					{ x: 0, y: 566.644 },
					{ x: 3, y: 949.962 },
					{ x: 4, y: 991.627 },
					{ x: 5, y: 949.962 },
					{ x: 9, y: 949.962 },
					{ x: 10, y: 966.628 },
					{ x: 11, y: 949.962 },
					{ x: 12, y: 949.962 },
					{ x: 14, y: 991.627 },
					{ x: 16, y: 991.627 },
					{ x: 17, y: 966.628 },
					{ x: 20, y: 1024.959 },
					{ x: 22, y: 1033.292 },
					{ x: 24, y: 1024.959 },
					{ x: 47, y: 1024.959 },
					{ x: 51, y: 1008.293 },
					{ x: 59, y: 1016.626 },
				],
				color: "var(--chart-blue)",
				texture: "dashed",
				legendLabel: "Weighted Round Robin",
			},
			{
				name: "Least Connections (LC) 50%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 1, y: 858.299 },
					{ x: 2, y: 808.301 },
					{ x: 3, y: 799.968 },
					{ x: 4, y: 858.299 },
					{ x: 5, y: 849.966 },
					{ x: 6, y: 866.632 },
					{ x: 8, y: 841.633 },
					{ x: 12, y: 841.633 },
					{ x: 13, y: 858.299 },
					{ x: 16, y: 858.299 },
					{ x: 17, y: 870.798 },
					{ x: 19, y: 874.965 },
					{ x: 20, y: 866.632 },
					{ x: 23, y: 866.632 },
					{ x: 27, y: 891.631 },
					{ x: 59, y: 898.145 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				legendLabel: "Least Connections",
			},
		],
	};
}
